import type { HTMLAttributes } from 'react';
import { useTranslations } from 'next-intl';
import { Subtitle } from '@silvertours/front-shared';
import { MarketField } from './MarketField';
import { CurrencyField } from './CurrencyField';
import { Container } from './RegionalSettings.styles';

type Props = {
  /**
   * Called after the currency has been changed. Used by the mobile menu to
   * close itself once a currency is picked.
   */
  onCurrencyChange?: (code: string) => void;
} & Pick<HTMLAttributes<HTMLDivElement>, 'className'>;

const RegionalSettings = ({ onCurrencyChange, className }: Props) => {
  const t = useTranslations(
    'features.navigationLegacy.navigation.header.regionalSettings',
  );

  return (
    <Container className={className}>
      <Subtitle as="p">{t('title')}</Subtitle>
      <MarketField />
      <CurrencyField onCurrencyChange={onCurrencyChange} />
    </Container>
  );
};

export { RegionalSettings };
